import { render, staticRenderFns } from "./CartContents.vue?vue&type=template&id=0057e3a2&scoped=true"
import script from "./CartContents.vue?vue&type=script&lang=js"
export * from "./CartContents.vue?vue&type=script&lang=js"
import style0 from "./CartContents.vue?vue&type=style&index=0&id=0057e3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057e3a2",
  null
  
)

export default component.exports